var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"success","min-height":"35","min-width":"120","rounded":"","loading":_vm.carregando},on:{"click":function($event){return _vm.finalizarInclusao()}}},[_vm._v("Finalizar")])
}
var staticRenderFns = []

export { render, staticRenderFns }